import { Directive, ElementRef, HostListener } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Directive({
  standalone: true,
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[matTooltip].truncate',
})
export class MatTooltipTruncateDirective {
  constructor(
    private readonly elRef: ElementRef<HTMLElement>,
    private readonly matTooltip: MatTooltip,
  ) {}

  @HostListener('mouseenter')
  onMouseEnter() {
    this.matTooltip.disabled = !this.isTruncated();
  }

  isTruncated() {
    const el = this.elRef.nativeElement;
    return el.scrollWidth > el.offsetWidth;
  }
}
